import { createStore, Store } from 'redux';
// import { initialState, oneFormReducer } from './redux/reducer';
import { OneFormState } from 'src/types';
import { initialState, oneFormReducer } from './feature-app';

export const store: Store<OneFormState> = createStore(oneFormReducer, initialState);
